import t from"./Stats.vue_vue&type=script&lang.js";import{render as e}from"./Stats.vue_vue&type=template&id=676a2d00&lang.js";t.render=e;export default t;
//# sourceMappingURL=Stats.vue.js.map
